import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ApiService } from '../services/api/api-service';
import { Router } from '@angular/router';

export const EncryptionInterceptor: HttpInterceptorFn = (req, next) => {

  const apiService = inject(ApiService);
  const router = inject(Router);

  const token = sessionStorage.getItem('token');

  let modifiedReq = req;

  const isLoginRequest = req.url.includes('login');

  if (!isLoginRequest && !token) {
    router.navigate(['/login']);
    return next(req);
  }

  if (token) {
    modifiedReq = modifiedReq.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  // if (modifiedReq.method === 'POST' && modifiedReq.body) {
  //   modifiedReq = modifiedReq.clone({
  //     body: {
  //       ency: apiService.encryptPayload(modifiedReq.body)
  //     }
  //   });
  // }

  return next(modifiedReq);
};
